<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click.self="$emit('close')"
  >
    <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
      <!-- Header -->
      <div class="flex justify-between items-center p-6 border-b">
        <h2 class="text-2xl font-bold text-gray-800">Keyboard Shortcuts</h2>
        <button
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6 space-y-6">
        <!-- Navigation Section -->
        <div>
          <h3 class="text-lg font-semibold text-gray-700 mb-3">Navigation</h3>
          <div class="space-y-2">
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Switch focus between panels</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">← →</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Navigate items in active panel</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">↑ ↓</kbd>
            </div>
          </div>
        </div>

        <!-- Assessment Modal Section -->
        <div>
          <h3 class="text-lg font-semibold text-gray-700 mb-3">Assessment Modal</h3>
          <div class="space-y-2">
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Open assessment modal for selected criterion</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Enter</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Close assessment modal</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Escape</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Increment / decrement countable value</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">↑ / ↓</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Type any character to focus text field and start writing</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">A-Z, 0-9</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Save</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Ctrl + Enter</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Save &amp; Publish</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Ctrl + P</kbd>
            </div>
          </div>
        </div>

        <!-- Other Section -->
        <div>
          <h3 class="text-lg font-semibold text-gray-700 mb-3">Other</h3>
          <div class="space-y-2">
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Toggle team mode</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Alt + T</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Toggle anonymous mode</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Alt + A</kbd>
            </div>
            <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded">
              <span class="text-gray-700">Switch active session</span>
              <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-sm font-mono">Alt + S</kbd>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex justify-end p-6 border-t bg-gray-50">
        <button
          @click="$emit('close')"
          class="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  watch: {
    isOpen(newVal) {
      // Prevent body scroll when modal is open
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  beforeUnmount() {
    // Cleanup: restore body scroll
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
kbd {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>
